import axiosInstance from "."

class NotificationService {
    async getNotifications(vacancyCompanyId: number | null, isAll?: boolean) {
        const params: any = {};
        if (isAll) {
            params.isAll = isAll;
        }
        params.vacancyCompanyId = vacancyCompanyId || null
        const response = await axiosInstance.get('/api/notification', { params });
        return response;
    }

    async skipNotification(id: number) {
        const response = await axiosInstance.patch('/api/notification/skip/' + id)
        return response
    }
}

const notificationService = new NotificationService()

export default notificationService